import React from "react";
import EODLogger from "./EODLogger";

export default function App() {
  return (
    <div className="App">
      <EODLogger />
    </div>
  );
}
